export default __webpack_public_path__ + "static/google_word-1847d066b1e30203d08e937324568a35.png";